import React, { Component } from 'react';
import { connect } from 'react-redux';

import {protocolCode ,bankCode} from '../BankCode'
import './PaymentSuperFund.css';
import Util from '../util';
import { Toast } from 'antd-mobile/lib';
import { getDoRedeemSuper,getFundsInfo,getExpectedDate, superFundPunishmentIn7Day, dianji} from '../action/investmentAction';
import { getRedeemToHqtvalidate } from '../action/productAction';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import Password from './myAssets/payment/Password'
import ModalList,{ AddCardHqtAlert, SuperModalTwo } from "./Modal/ModalList";
import {getTempInfo} from '../common';
import {AlerModleCommon} from './fundDetail/AlerModle';
import { choseCurrencyIndex } from "../action/productAction"

class RedeemSuperFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text:'',
      btnFlag:false,
      pwdFlag:false,
      keyPasswordVal:'',
      active:1,
      currencyArr:[],
      currencyArrIndex:0,
      currencyFlag:false,
      setModalShow: false,
      expectedDateArr:{
        moneyFundExpectedDate:'--',
        bankCardExpectedDate:'--',
      },
      limitFlag:false,
      sevenDayFlag:false,
      partialRedeem:false,
      numVal: "",
      BoolVlue: false,
      Bool: false,
      Tiac: false,
      Colr: "",
      baiFen: "",
      BoolVlues: false,
      Num : ""
    };
  }
  componentWillUnmount(){
  
  }

  async componentWillMount() {
    let {fundCode,cardList}=this.props.location.state;
    let {selectCurrentIndex}=this.props
    
    console.log(cardList,selectCurrentIndex)
    document.title = "赎回"
    if(Util.superFundCodeArrByTarget.indexOf(fundCode) != -1){
      this.allConver();
  }
    this.props.dispatch(getFundsInfo((result)=>{this.getFundsInfo(result)}))
    let data={
      superFundCode:fundCode,
      token: await getTempInfo('shortToken'),
      trustChannelId:cardList[selectCurrentIndex].trustChannelId
    }
    console.log(data,'获取到款时间')
    this.props.dispatch(getExpectedDate(data,(result)=>{
      this.getExpectedDate(result)
    }))
  }
  getExpectedDate(result){
    this.setState({
      expectedDateArr:result.content
    })
  }
  getFundsInfo(result){
    console.log(result)
    let newData = [];
    if(result.content) {
      newData = [].concat(result.content);
      if(this.props.location.state &&
         this.props.location.state.cardList && 
         this.props.location.state.cardList.length > 0 &&
         this.props.location.state.cardList[this.props.selectCurrentIndex].capitalChannelId != "y") {

      }else {
        newData.push({
          fundname: "活期通",
          fundtext: "赎回资金将默认转入当前活期通账户中七日年化收益率最高的产品"
        });
      }
    }
    this.setState({
      currencyArr:newData
    })
    this.backFunHqt(newData);
  }
  next(){
    const { 
      dispatch,selectCurrentIndex
    }=this.props;
    let {cardList,fundCode}=this.props.location.state;
    let baiFenVal = ""
    if(this.state.baiFen.indexOf("%")!=-1){
      baiFenVal = this.state.baiFen.substring(0,this.state.baiFen.length-1)
    }else{
      baiFenVal = this.state.baiFen
    }
    if (!cardList) {
      Toast.info( '请选择赎回渠道', Util.ToastTime );
      return;
    } 
    if(!Number.isInteger(Number(baiFenVal))) {
      Toast.info( '请输入整数可转出比例', Util.ToastTime );
      return;
    } 
    if(cardList[selectCurrentIndex].canRedeemAmount - 0 <= 0) {
      Toast.info( '可赎回份额为0，不能赎回', Util.ToastTime );
      return;
    }
    // if (cardList[selectCurrentIndex].status=='adjust') {
    //   Toast.info( '调仓中不允许赎回', Util.ToastTime );
    //   return;
    // }
    // if(cardList[selectCurrentIndex].canRedeemAmount-0 >= 500){
    //   if(this.state.text-0 < 500){
    //     let toast = Toast.info( '赎回金额不可低于500元', Util.ToastTime );
    //     return;
    //   }
    // }
    // if (cardList[selectCurrentIndex].canRedeemAmount-0<this.state.text-0) {
    //   Toast.info( '赎回金额不可超过可赎回金额', Util.ToastTime );
    //   return;
    // }
    // if(this.state.text-0!=cardList[selectCurrentIndex].canRedeemAmount-0){
    //   if(this.state.text-0 > (cardList[selectCurrentIndex].canRedeemAmount-0)*0.8 || (cardList[selectCurrentIndex].canRedeemAmount-0)-(this.state.text-0)< 500){
    //     this.setState({
    //       limitFlag: true
    //     })
    //     return;
    //   }
    // }
    // if (this.state.amount-0>=cardList[selectCurrentIndex].totalAmount-0) {
    //   if (this.state.text-0!=cardList[selectCurrentIndex].totalAmount-0) {
    //     let toast = Toast.info( '赎回额低于交易最低限额，请全部赎回', Util.ToastTime );
    //     return;
    //   }
    // } else{
    //   if (cardList[selectCurrentIndex].totalAmount-0<this.state.text-0) {
    //     Toast.info( '赎回金额不可超过可赎回金额', Util.ToastTime );
    //     return;
    //   }
    // }
    let params = {
      fundCode: fundCode,
      businessType: 'T024',
      trustChannelId: cardList[selectCurrentIndex].trustChannelId
    }
    dispatch(superFundPunishmentIn7Day(params,(result)=>{
      console.log(result);
      if(result.content){
        this.setState({
          sevenDayFlag: true
        })
      }else{
        if(this.state.active==1){
          if(this.state.currencyArr[this.props.currencyIndex].fundname == "活期通") {
            this.setState({
              pwdFlag:true
            })
          }else {
            this.setState({
              setModalShow: true
            })
          }
        }else{
          this.setState({
            pwdFlag:true
          })
        }
      }  
    }))
  }
  //七日赎回确认
  onNext(){
    this.setState({
      sevenDayFlag:false
    },()=>{
      if(this.state.active==1){
        if(this.state.currencyArr[this.props.currencyIndex].fundname == "活期通") {
          this.setState({
            pwdFlag:true
          })
        }else {
          this.setState({
            setModalShow: true
          })
        }
      }else{
        this.setState({
          pwdFlag:true
        })
      }
    })
  }
  onChangeText(e){
    let {
      cardList
    }=this.props.location.state;
    let zdnum = Util.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount)
    let minRedeemRatestr = cardList[this.props.selectCurrentIndex].minRedeemRate
    let maxRedeemRatestr = cardList[this.props.selectCurrentIndex].maxRedeemRate
    // if(minRedeemRatestr<=e.target.value*1 && maxRedeemRatestr>=e.target.value){
      if(e.target.value=="10"){
        this.setState({Colr:0.1})
      }else if(e.target.value=="20"){
        this.setState({Colr:0.2})
      }else if(e.target.value=="30"){
        this.setState({Colr:0.3})
      }else if(e.target.value=="50"){
        this.setState({Colr:0.5})
      }else if(e.target.value=="80"){
        this.setState({Colr:0.8})
      }else if(e.target.value=="100"){
        this.setState({Colr:1})
      }else{
        this.setState({Colr:""})
      }
    // }else{
    //   this.setState({Colr:""})
    // }
    let maxmin = ""
    if(minRedeemRatestr>e.target.value*1 || maxRedeemRatestr<e.target.value*1){
      if(e.target.value*1==100 && zdnum>0){
        this.setState({
          BoolVlue: false
        })
        maxmin=false
      }else{
        this.setState({
          BoolVlue: true
        })
        maxmin=true
      }
    }else{
      this.setState({
        BoolVlue: false
      })
      maxmin=false
    }
    if(e.target.value===""){
      this.setState({
        BoolVlue: false,
        BoolVlues: false
      })
      maxmin=false
    }else{
      this.setState({
        BoolVlues: true
      })
    }
    this.setState({
      text: (e.target.value*1/100)*zdnum,
      baiFen: e.target.value
    })
    let flag=Util.regular1.test(e.target.value)
    if (flag&&e.target.value!==''&&!maxmin) {
      this.setState({
          btnFlag:true
      })
      
    }else{
      this.setState({
          btnFlag:false
      })
    }
   
  }
  choseBank(){
    let {cardList}=this.props.location.state;
      hashHistory.push({
        pathname: '/RedeemBankList',
        state: {
          dataSouse:cardList,
          Fun: (i)=>{this.setState({Num:i})}
        }
      });
  }
  onChangePwd(val){
    this.setState({
      keyPasswordVal:val
    })
  }
  btnCallBack1(){

  }
  btnCallBack2(){

  }
  keyOk(){
    const { 
      navigator,
      businessType,
      dispatch,
      bankOrCurrent,
      selectCurrentIndex,
      keyPasswordVal,
      trustChannelShare,
      
    }=this.props;
    let {cardList,fundCode,fundName}=this.props.location.state;
    if (!cardList) {
      return;
    } 
    let {baiFen}=this.state;
    let _this=this;
    const pushResult = (i,result) => {
      console.log(i,result)
      if (i==1) {
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'赎回完成',
              content:'您的赎回申请已被受理',
              dataSouse:[['申请编号',result.content],['产品名称',fundName],['赎回比例',baiFen.replace(/[^0-9]/ig,"")+"%"]],
              souseVal:['查看我的智投']
            }
          });
      } else if (i==3) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'赎回完成',
              content:'很抱歉,赎回申请失败。',
              content2:result,
              dataSouse:[],
              souseVal:['查看我的智投']
            }
          });
      }
    }  
    if(this.state.currencyArr[this.props.currencyIndex].fundname == "活期通" && this.state.active==1) {
      let data = {
        fundCode: fundCode,
        largeRedemptionFlag: '1',
        trustChannelId: cardList[selectCurrentIndex].trustChannelId,
        redeemAmount: this.state.text,
        password: Util.encrypt(this.state.keyPasswordVal),
        redeemRate:Number(this.state.baiFen.replace(/[^0-9]/ig,"")) //赎回比例
      }
      dispatch(getRedeemToHqtvalidate(data,pushResult))
    }else {
      if (this.state.active==1) {
        let data={
          superFundCode:fundCode,
          monetaryFund:this.state.currencyArr[this.props.currencyIndex].fundcode,
          trustChannelId:cardList[selectCurrentIndex].trustChannelId,
          password:Util.encrypt(this.state.keyPasswordVal),
          redeemToCard:false,
          redeemRate:Number(this.state.baiFen.replace(/[^0-9]/ig,"")) //赎回比例
        }
        dispatch(getDoRedeemSuper(data,pushResult))
      }else{
        let data={
          superFundCode:fundCode,
          trustChannelId:cardList[selectCurrentIndex].trustChannelId,
          password:Util.encrypt(this.state.keyPasswordVal),
          redeemToCard:true,
          redeemRate:Number(this.state.baiFen.replace(/[^0-9]/ig,"")) //赎回比例
        }
        dispatch(getDoRedeemSuper(data,pushResult))
      }
    }
    
  }
  allConver(){
    let {totalAmount,cardList}=this.props.location.state;
     let {trustChannelShare,selectCurrentIndex}=this.props;
    if (!cardList) {
      return;
    } 
    this.setState({
      text:Util.fomatFloat(cardList[selectCurrentIndex].canRedeemAmount,2).toString(),
    })
    if (cardList[selectCurrentIndex].canRedeemAmount!==0) {
      this.setState({
        btnFlag:true
      })
    }
    
  }
  choseTab(i){
    this.props.dispatch(dianji(i))
    this.setState({
      active:i
    })
  }
  ChoseCurrency(){
    this.setState({
      Bool:true
    })
    // hashHistory.push({
    //   pathname: "/RedeemCurrencyList",
    //   query:{
    //     dataSouse:this.state.currencyArr
    //   },
    //   state: {
    //     dataSouse:this.state.currencyArr
        
    //   }
    // });
  }
	agreeFunSec = () => {
		this.setState({
      setModalShow: false,
      pwdFlag:true
		});
	}

  componentDidMount(){
    let {
      cardList
    }=this.props.location.state;
    let zdnum = Util.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount)
    if(zdnum==0){
      this.setState({numVal:"0"})
    }
    this.setState({active:this.props.dianji?this.props.dianji:1})
    this.props.dispatch(getFundsInfo((result)=>{this.getFundsInfo(result)}))
    if(cardList[this.props.selectCurrentIndex].maxRedeemRate==100 && cardList[this.props.selectCurrentIndex].minRedeemRate==100){
      this.setState({
        Colr: 1,
        text: zdnum,
        baiFen: "100%"
      })
      if(Util.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount)>0){
        this.setState({btnFlag:true})
      }else{
        this.setState({btnFlag:false})
      }
    }
  }

  onFun = (val) =>{
    let {
      cardList
    }=this.props.location.state;
    let zdnum = Util.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount)
    if(this.state.numVal!=="0"){
      this.setState({
        text: (val*zdnum),
        btnFlag:true,
        BoolVlue:false,
        Colr: val,
        baiFen: (val*100)+"%",
        BoolVlues: false
      })
    }else{
      this.setState({
        btnFlag:false,
        BoolVlue:false,
        BoolVlues: false,
        baiFen: (val*100)+"%",
        Colr: val,
      })
    }
  }
  changeIndex(item,i){
    this.setState({
      Bool: false
    })
    this.props.dispatch(choseCurrencyIndex(i))
  }
  fanhui(){
    this.props.dispatch(dianji(1))
    hashHistory.goBack()
  }
  backFunHqt = (cerArr) => {
    if(this.props.location.state && this.props.location.state.cardList && this.props.location.state.cardList.length > 0 && cerArr.length > 0) {
      let dataList = cerArr;
      let newData = [];
      if(this.props.location.state.cardList[this.props.selectCurrentIndex].capitalChannelId != "y") {
        for(let i = 0; i < dataList.length; i++) {
          if(dataList[i].fundname != "活期通") {
            newData.push(dataList[i]);
          }
        }
        if((dataList[this.props.currencyIndex] && dataList[this.props.currencyIndex].fundname == "活期通") || (this.props.currencyIndex - 0 > dataList.length - 1)) {
          this.props.dispatch(choseCurrencyIndex(0))
          this.setState({
            currencyArr: newData
          });
        }else {
          for(let i = 0; i < newData.length; i++) {
            if(newData[i].fundname == dataList[this.props.currencyIndex].fundname) {
              this.props.dispatch(choseCurrencyIndex(this.props.currencyIndex))
              this.setState({
                currencyArr: newData
              });
              break;
            }
          }
        }
      }else {
        let Flag = false;
        for(let i = 0; i < dataList.length; i++) {
          newData.push(dataList[i]);
          if(dataList[i].fundname == "活期通") {
            Flag = true;
          }
        }
        if(!Flag) {
          newData.push({
            fundname: "活期通",
            fundtext: "赎回资金将默认转入当前活期通账户中七日年化收益率最高的产品"
          });
        }
        for(let i = 0; i < newData.length; i++) {
          if(newData[i].fundname == dataList[this.props.currencyIndex].fundname) {
            this.props.dispatch(choseCurrencyIndex(this.props.currencyIndex))
            this.setState({
              currencyArr: newData
            });
            break;
          }
        }
      }
    }
  }
  render(){
    console.log(Number(this.state.baiFen.replace(/[^0-9]/ig,"")))
    let {
      fundName,
      fundCode, 
      totalAmount,
      cardList
    }=this.props.location.state;//nav 传入
    let jinVal = cardList[this.props.selectCurrentIndex].minRedeemRate+"%-"+cardList[this.props.selectCurrentIndex].maxRedeemRate+"%"+"或100%"
    const img_arr = [require('../img/square.png'),require('../img/protocol_selected.png')]
    let icon=[require('../img/circleHookG.png'),require('../img/xuanzhong.png')];
    console.log(cardList,this.state.text)
    let _this=this;
    let {selectCurrentIndex}=this.props;
    let {Colr}=this.state
    return (
        <div className="container" >
          <NavigatorMain>
          <div className="headerblacks">
            <div onClick={()=>{this.fanhui()}}><span className="headerLeftBtn"></span></div>
            <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"0.36rem"}}>赎回</div>
            <div style={{width:"44px"}}></div>
          </div>
          </NavigatorMain>
          <div className='content'>
            {
              this.state.Bool?
              <div onClick={()=>{this.setState({Bool:false})}} style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",background:"rgba(0,0,0,0.5)",zIndex:100}}>
                <div style={{position:"fixed",bottom:0,left:0,width:"100%",height:"50%",background:"#fff",overflow:"auto",borderTopLeftRadius:"0.2rem",borderTopRightRadius:"0.2rem",paddingTop:".4rem"}}>
                  {
                    this.state.currencyArr.map( (item,i)=> {
                      if(item.fundname == "活期通"){
                        return(
                          <div key={i} className='currencyList' onClick={()=>this.changeIndex(item,i)}>
                            <div>
                              <div style={{color:'#333333',fontSize:16}}>{item.fundname}</div>
                              <div style={{color:'#666666',fontSize:14}}>{item.fundtext}</div>
                            </div>
                            <div className='bankListRightOK'>
                              <img src={this.props.currencyIndex===i?icon[1]:icon[0]} className={this.props.currencyIndex===i?'xuanzhongimg':"img"}/>
                            </div>
                          </div>
                        )
                      }else{
                        return(
                          <div key={i} className='currencyList' onClick={()=>this.changeIndex(item,i)}>
                            <div>
                              <div style={{color:'#333333',fontSize:16,fontWeight:"500"}}>{item.fundname}<span style={{color:"#cccccc",fontSize:"0.3rem",marginBottom:"0.04rem",flex:1,marginLeft:".08rem"}}>{">"}</span>{i==0?<div className='znyx'/>:null}</div>
                              <div style={{color:'#F8515C',fontSize:".32rem",fontWeight:"500"}}>{item.wanfenshouyi}<div style={{color:'#F8515C',fontSize:".32rem",fontWeight:"500",width:"2rem",marginLeft:"2rem",paddingLeft:"0.05rem"}}>{item.qirinianhua}%</div></div>
                              <div style={{color:'#666666'}}>万分收益<div style={{width:"2rem",marginLeft:"2rem"}}>7日年化收益</div></div>
                            </div>
                            <div className='bankListRightOK'>
                              <img src={this.props.currencyIndex===i?icon[1]:icon[0]} className={this.props.currencyIndex===i?'xuanzhongimg':"img"}/>
                            </div>
                          </div>
                        )
                      }
                    })
                  }
                </div>    
              </div>:
              null
            }
            <div className='headerActive'>
              <div style={{paddingTop:"3px"}}>
                <div onClick={()=>this.choseTab(1)} style={{fontSize: "0.32rem",fontWeight:"bold", color:this.state.active==1?'#FFFFFF':'rgba(255, 255, 255, 0.7)'}}>转出至货币基金</div>
                <div onClick={()=>this.choseTab(2)} style={{fontSize: "0.32rem",fontWeight:"bold", color:this.state.active==2?'#FFFFFF':'rgba(255, 255, 255, 0.7)'}}>转出至银行卡</div>
              </div>
              <div style={{display:"flex",paddingTop:"0.1rem"}}>
                <div style={{flex:1,textAlign:"center"}}><span className={this.props.dianji==1?'active':this.state.active==1?"active":null}></span></div>
                <div style={{flex:1,textAlign:"center"}}><span className={this.props.dianji==2?'active':this.state.active==2?"active":null}></span></div>
              </div>
            </div>
            <div className='contentHeader'>
              <div style={{fontSize: "0.32rem",fontWeight:"500",color:'#333333'}}>{`${this.props.location.state.fundName}(${this.props.location.state.fundCode})`}</div>
            </div>
            <div style={{marginTop:"10px",backgroundColor:"#fff"}}>
              <div style={{paddingLeft:"0.26rem",paddingRight:"0.26rem",paddingTop:"0.2rem",paddingBottom:"0.4rem"}}><span style={{fontSize:"0.32rem",marginRight:"0.8rem",fontWeight:"500",color:'#333333'}}>转出比例</span><span style={{color:"#999999"}}>{this.state.BoolVlue?"｜":""}</span><span style={{color:"red",fontSize:"0.24rem"}}>{this.state.BoolVlue?"转出比例超限":""}</span></div>
              <div className='input'>
                <p style={{fontSize: "0.48rem",fontWeight:"500",color:'#333333'}}>¥</p>
                <input
                 disabled={Util.superFundCodeArrByTarget.indexOf(fundCode) != -1 ? true:false} 
                //  disabled={false} 
                 autocomplete="off" placeholder={`可转出比例${jinVal}`} onChange={(e)=>this.onChangeText(e)} type="text" value={this.state.baiFen} style={{backgroundColor:"#fff",fontSize: "0.38rem",fontWeight:"500",color:'#333333',marginLeft:"-20px"}} />
                {/* {
                  Util.superFundCodeArrByTarget.indexOf(fundCode) != -1 ? null:
                  <p className='red-t' onClick={()=>this.allConver()}>全部赎回</p>
                } */}
                {
                this.state.BoolVlues?
                <div style={{fontSize: "0.38rem",fontWeight:"500",color:'#333333',paddingTop:"0.1rem"}}>%</div>
                :null
              }
              </div>
              {
                cardList && cardList.length > 0 ?
                <div style={{display:"flex",paddingBottom:"30px",paddingTop:"20px",paddingLeft:"13px"}}>
                  <div onClick={cardList[this.props.selectCurrentIndex].maxRedeemRate>=10 && cardList[this.props.selectCurrentIndex].minRedeemRate<=10?()=>{this.onFun(0.1)}:()=>{}} className={[cardList[this.props.selectCurrentIndex].maxRedeemRate>=10 && cardList[this.props.selectCurrentIndex].minRedeemRate<=10?Colr==0.1?"biliss":"bili":"bilis"]}>10%</div>
                  <div onClick={cardList[this.props.selectCurrentIndex].maxRedeemRate>=20 && cardList[this.props.selectCurrentIndex].minRedeemRate<=20?()=>{this.onFun(0.2)}:()=>{}} className={[cardList[this.props.selectCurrentIndex].maxRedeemRate>=20 && cardList[this.props.selectCurrentIndex].minRedeemRate<=20?Colr==0.2?"biliss":"bili":"bilis"]}>20%</div>
                  <div onClick={cardList[this.props.selectCurrentIndex].maxRedeemRate>=30 && cardList[this.props.selectCurrentIndex].minRedeemRate<=30?()=>{this.onFun(0.3)}:()=>{}} className={[cardList[this.props.selectCurrentIndex].maxRedeemRate>=30 && cardList[this.props.selectCurrentIndex].minRedeemRate<=30?Colr==0.3?"biliss":"bili":"bilis"]}>30%</div>
                  <div onClick={cardList[this.props.selectCurrentIndex].maxRedeemRate>=50 && cardList[this.props.selectCurrentIndex].minRedeemRate<=50?()=>{this.onFun(0.5)}:()=>{}} className={[cardList[this.props.selectCurrentIndex].maxRedeemRate>=50 && cardList[this.props.selectCurrentIndex].minRedeemRate<=50?Colr==0.5?"biliss":"bili":"bilis"]}>50%</div>
                  <div onClick={cardList[this.props.selectCurrentIndex].maxRedeemRate>=80 && cardList[this.props.selectCurrentIndex].minRedeemRate<=80?()=>{this.onFun(0.8)}:()=>{}} className={[cardList[this.props.selectCurrentIndex].maxRedeemRate>=80 && cardList[this.props.selectCurrentIndex].minRedeemRate<=80?Colr==0.8?"biliss":"bili":"bilis"]}>80%</div>
                  {/* <div onClick={cardList[0].maxRedeemRate>=100 && cardList[0].minRedeemRate<=100?()=>{this.onFun(1)}:()=>{}} className={[cardList[0].maxRedeemRate>=100 && cardList[0].minRedeemRate<=100?Colr==1?"biliss":"bili":"bilis"]}>100%</div> */}
                  <div onClick={()=>{this.onFun(1)}} className={[Colr==1?"biliss":"bili"]}>100%</div>
                </div> 
                :
                <div style={{display:"flex",paddingBottom:"30px",paddingTop:"20px",paddingLeft:"13px"}}>
                  <div onClick={()=>{}} className={["bilis"]}>10%</div>
                  <div onClick={()=>{}} className={["bilis"]}>20%</div>
                  <div onClick={()=>{}} className={["bilis"]}>30%</div>
                  <div onClick={()=>{}} className={["bilis"]}>50%</div>
                  <div onClick={()=>{}} className={["bilis"]}>80%</div>
                  {/* <div onClick={cardList[0].maxRedeemRate>=100 && cardList[0].minRedeemRate<=100?()=>{this.onFun(1)}:()=>{}} className={[cardList[0].maxRedeemRate>=100 && cardList[0].minRedeemRate<=100?Colr==1?"biliss":"bili":"bilis"]}>100%</div> */}
                  <div onClick={()=>{this.onFun(1)}} className={[Colr==1?"biliss":"bili"]}>100%</div>
                </div> 
              }
            </div>
            <div className='shares'>
              <div style={{display:"flex",flex:1,fontSize:"0.32rem",fontWeight:"500",color:'#333333'}}>
                转出资金来源
              </div>
              {
                cardList?<div onClick={()=>_this.choseBank()} className='bankList'>
                  <img src={bankCode['ty'][cardList[selectCurrentIndex].bankCode]?bankCode['ty'][cardList[selectCurrentIndex].bankCode]:require('../img/bank.png')} style={{width:".3rem",height:".3rem",marginTop:".4rem",marginRight:"5px"}}/>
                  <div className='bankListTip'>
                    <p>{cardList[selectCurrentIndex].trustChannelName}</p>
                    <p>可赎回金额:<span style={{color:"#B69271"}}>{Util.parsePrice(cardList[selectCurrentIndex].canRedeemAmount)}元</span></p>
                    {
                      !cardList[selectCurrentIndex].allAmountCanUse ? <p style={{color:'rgb(104,113,126)',fontSize:10, paddingTop:2 }} >{ "部分成分基金暂停赎回/转换" } </p> : null
                    }
                  </div>
                  <div className='bankListRight'>
                  </div>
                </div>:null
              }
            </div>
            {
              this.state.active==1?<div className='redeemCurrency' onClick={()=>this.ChoseCurrency()}>
                <div style={{fontSize:"0.32rem",fontWeight:"500",color:'#333333'}}>转出至</div><div style={{fontWeight:"400",color:'#333333'}}>{this.state.currencyArr.length>0&&this.state.currencyArr[this.props.currencyIndex]?this.state.currencyArr[this.props.currencyIndex].fundname:'--'}
                {
                  this.props.currencyIndex==0?<div className='znyx'/>:null
                }
                <div className='rightImg'/>
                </div>
              </div>:null
            }
             <div style={{
               paddingLeft: "13px",
               flexDirection: "row",
               display: 'flex',
               height:"20px",
               marginTop: "10px",
               fontSize: "0.24rem",
               alignItems: 'center'
             }}>
               <p style={{color:"#B69271"}}>预计</p>
               <p className='red-ts'>
               {
                  this.props.dianji?
                  this.props.dianji==1?
                  this.state.expectedDateArr.moneyFundExpectedDate:this.state.expectedDateArr.bankCardExpectedDate
                  :this.state.expectedDateArr.moneyFundExpectedDate
               }
               </p>
               <p style={{color:'#999999'}}>到账，请以实际到账时间为准</p>
            </div>
            {
              this.state.btnFlag?<div onClick={()=>{ cardList[selectCurrentIndex].allAmountCanUse ? cardList[selectCurrentIndex].status=='adjust' ? this.setState({ Tiac:true }) : this.next() : this.setState({ Tiac:true }) }} className='btn'>提交</div>:
              <div  className='btn btn-gray'>提交</div>
            }
            <div style={{marginTop:30}}>
              <footer className='superFooter'>
              <p style={{height:30,fontSize:"12px",color:"#999999",fontWeight:"bold"}}>特别提示 :</p>
                <p style={{color:'#999999',fontSize:"12px",lineHeight:'22px',fontWeight:"bold"}}>1、本业务暂不支持撤单。</p>
                <p style={{color:'#999999',fontSize:"12px",lineHeight:'22px',fontWeight:"bold"}}>2、基金投资组合策略的风险特征与单只基金产品的风险特征存在差异。</p>
                <p style={{color:'#999999',fontSize:"12px",lineHeight:'22px',fontWeight:"bold"}}>3、基金净值会因证券市场波动等因素波动，可能导致损失。</p>
                <p style={{color:'#999999',fontSize:"12px",lineHeight:'22px',fontWeight:"bold"}}>4、管理人投资判断会有差异从而影响基金的收益水平，可能发生损失。</p>
                <p style={{color:'#999999',fontSize:"12px",lineHeight:'22px',fontWeight:"bold"}}>5、若管理人业务或财务状况变化，可能影响投资者判断，也可能导致损失。</p>
                <p style={{color:'#999999',fontSize:"12px",lineHeight:'22px',fontWeight:"bold"}}>6、投资者可以通过录音、截屏等方式留存基金投资顾问服务的相关信息。</p>
              </footer>
            </div>
          </div>
          <ModalList flag={this.state.setModalShow} title = '温馨提示' content = '您的赎回资金将自动申购为华夏财富零钱宝货币份额，在组合赎回成功后，您可以在华夏财富APP或官网查询零钱宝份额。' btnRight = '我知道了' btnRightFun = {this.agreeFunSec} />

          {
            this.state.partialRedeem ? <SuperModalTwo title = '温馨提示' content = '由于部分成分基金暂停赎回/转换，现在赎回可能会影响您后续投资方案，是否继续？' 
              buttonText1 = { "继续赎回" }  buttonText2="我再想想"
              handleBtnOne = { () =>  { this.next(); this.setState({partialRedeem: false});  } } 
              handleBtnTwo = {() => { this.setState({partialRedeem: false}); }} 
              handleCancel = {() => { this.setState({partialRedeem: false}); }} 
            /> : null
          }
          {
            this.state.Tiac ? <SuperModalTwo title = '' content = '您持有组合正在调仓，现在赎回会导致持仓偏移，确定要转出吗？' 
              buttonText1 = { "确认转出" }  buttonText2="我再想想"
              handleBtnOne = { () =>  { this.next(); this.setState({Tiac: false});  } } 
              handleBtnTwo = {() => { this.setState({Tiac: false}); }} 
              handleCancel = {() => { this.setState({Tiac: false}); }} 
            /> : null
           }
          {
            this.state.pwdFlag?
            <Password _this={this}/>
            :null
          }
          {/* {
          this.state.limitFlag ?
             <AlerModleCommon 
             btnTxt1="全部赎回"
             btnTxt2="取消"
             content={"本次赎回已超过总资产80%或剩余资产不足500元，是否全部赎回？"} 
             title="特别提示"
             handleClick1 = {()=>{this.setState({limitFlag:false});this.allConver()}}
             handleClick2 = {()=>{this.setState({limitFlag:false})} }
           /> : null
           } */}
           {
             this.state.sevenDayFlag ?
             <AlerModleCommon 
             btnTxt1="确认"
             btnTxt2="取消"
             content={"自交易日2018年3月30日起，若投资者赎回除货币及交易型开放式指数基金以外的开放式基金时持续持有期少于7日（自然日），将被收取不低于1.5%的赎回费。具体赎回费率请参见产品说明。"} 
             title="特别提示"
             handleClick1 = {()=>{this.onNext()}}
             handleClick2 = {()=>{this.setState({sevenDayFlag:false})} }
           /> : null
           }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    selectCurrentIndex:state.selectCurrentIndex,
    currencyIndex:state.currencyIndex,
    dianji:state.dianji,
  }
}
export default connect(mapStateToProps)(RedeemSuperFund);



// WEBPACK FOOTER //
// ./src/components/RedeemSuperFund.js